<template>
  <div class="section-login">
    <router-view></router-view>
    <div class="section-login__copyright">
      <span>&copy; {{ new Date().getFullYear() }} {{ $t('VividLeaf') }}</span>
      <a class="linkGray" href="http://vivid-leaf.com/index.php?page=imprint" target="_blank" rel="noopener noreferrer">
        {{ $t('imprint') }}
      </a>
      |
      <a
        class="linkGray"
        href="https://brodtmann-consulting.com/index.php?page=dataPrivacy"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ $t('privacyPolicy') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotAuthLayout',
};
</script>

<style scoped>
.test {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
